import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { PageLayouts, RouteBreadCrumb, useCheckRelations } from "components/common";
import CreateSelfInvoiceView from "./createView";
import { useInvoiceService, useSelfInvoiceService } from "serviceHooks";
import { useParams } from "react-router-dom";
import { useInvoicePermissions } from "components/invoice";
import { ErrorView } from "components/error";
import SelfInvoiceDetailsView from "./detailsView";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CreateSelfInvoiceViewContainer: React.FC = () => {
  const selfInvoiceService = useSelfInvoiceService();
  const invoiceService = useInvoiceService();

  const [loading, setLoading] = React.useState(true);
  const [notFound, setNotFound] = React.useState<boolean>();
  const [selfInvoice, setSelfInvoice] = React.useState<WintSuperkollAPIModel.SelfInvoice>();
  const [draftCustomerInvoice, setDraftCustomerInvoice] = React.useState<WintSuperkollAPIModel.Invoice>();

  const urlParams = useParams<EntityIdParams>();
  const id = urlParams.id;

  const { getIsAuditor } = useCheckRelations();
  const isAuditor = getIsAuditor();
  const { canCreateInvoices } = useInvoicePermissions();

  React.useEffect(() => {
    loadInvoice(id);
  }, [id]);

  const loadInvoice = (id?: string) => {
    if (id) {
      selfInvoiceService
        .get(id)
        .then((res) => {
          if (res === undefined) {
            setNotFound(true);
            setLoading(false);
            return;
          }

          setSelfInvoice(res);
          const draftCustomerInvoiceId = res.draftInvoiceId;
          if (draftCustomerInvoiceId) {
            invoiceService
              .get(draftCustomerInvoiceId)
              .then((res) => {
                setDraftCustomerInvoice(res);
              })
              .finally(() => setLoading(false));
          } else {
            setLoading(false);
          }
        })
        .catch(() => setLoading(false));
    }
  };

  const isEdit = selfInvoice?.state === WintSuperkollAPIModel.SelfInvoiceState.ApprovedToSendToCustomer;

  return notFound ? (
    <ErrorView />
  ) : (
    <PageLayouts.EntityFullScreen
      id={0}
      entityKey={`selfInvoice`}
      navigation={
        <RouteBreadCrumb
          current={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.CreateInvoice)}
          showHome
        />
      }
      hasPermissions={!isAuditor && canCreateInvoices}
      hideSpeedDial
      loading={loading}
    >
      {isEdit ? (
        <CreateSelfInvoiceView
          invoice={selfInvoice}
          draftCustomerInvoice={draftCustomerInvoice}
          loading={loading}
          reloadInvoice={loadInvoice.bind(null, id)}
        />
      ) : selfInvoice ? (
        <SelfInvoiceDetailsView selfInvoice={selfInvoice} />
      ) : (
        <></>
      )}
    </PageLayouts.EntityFullScreen>
  );
};

export default CreateSelfInvoiceViewContainer;
